<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="w-full flex flex-col md:flex-row mt-4 lg:mt-8">
      <div class="w-full lg:w-1/2">
        <div class="flex flex-col items-center mb-6">
          <div class="w-6/12 px-4 mb-6">
            <img
              alt="..."
              class="shadow rounded-full max-w-full h-auto align-middle border-none"
              :src="profilePicture?profilePicture:imgPlaceholder"
            />
          </div>
          <div class="flex flex-col mb-2">
            <p class="text-xs text-gray-700">We'll crop your image to a 900×900 square.</p>
          </div>
          <div class="flex flex-col mb-2" v-if="labelErrorImageMessage !== ''">
            <text-error v-if="labelErrorImageMessage !== ''" :text="labelErrorImageMessage" />
          </div>
          <div class="flex">
            <Button label="Browse File" v-if="!profilePicture">
              <template v-slot:any>
                <input style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;opacity: 0;cursor: pointer;z-index: 2;"
                       type="file"
                       name="profile_picture"
                       accept="image/*"
                       @change="onFileChange"
                />
              </template>
            </Button>
            <Button label="Remove" variant="default" v-if="profilePicture" @clicked="changeImage"></Button>
          </div>
        </div>
        <ImageCropModal
          :show="showCropModal"
          :image-src="pendingImageSrc"
          title="Crop Profile Picture"
          @cropped="onCropCropped"
          @cancel="onCropCancel"
        />
        <form-item label='First Name'>
          <template v-slot>
            <Input
              v-model="first_name"
              placeholder="First Name"
              :error="$v.first_name.$dirty && (!$v.first_name.required || !$v.first_name.maxLength)"
            />
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.first_name.$dirty && !$v.first_name.required" text="Please fill your first name." />
              <text-error v-if="$v.first_name.$dirty && !$v.first_name.maxLength" text="Maximum character for name is 100 characters." />
            </div>
          </template>
        </form-item>
        <form-item label='Last Name'>
          <template v-slot>
            <Input
              v-model="last_name"
              placeholder="Last Name"
              :error="$v.last_name.$dirty && (!$v.last_name.required || !$v.last_name.maxLength)"
            />
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.last_name.$dirty && !$v.last_name.required" text="Please fill your last name." />
              <text-error v-if="$v.last_name.$dirty && !$v.last_name.maxLength" text="Maximum character for name is 100 characters." />
            </div>
          </template>
        </form-item>
        <form-item label='Email'>
          <template v-slot>
            <Input
              v-model="email"
              placeholder="Email"
              :error="$v.email.$dirty && (!$v.email.required || !$v.email.email || errIsEmailExist)"
            />
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.email.$dirty && !$v.email.required" text="Please fill your email." />
              <text-error v-if="$v.email.$dirty && !$v.email.email" text="Please fill your correct email." />
              <text-error v-if="$v.email.$dirty && errIsEmailExist" text="Email is already in use." />
            </div>
          </template>
        </form-item>
        <form-item label='Language'>
          <template v-slot>
            <el-select v-model="language" filterable placeholder="Select Language"
                       :class=" $v.language.$dirty && $v.language.$anyError ? 'border-red-500' : ''" class="w-full">
              <el-option
                v-for="item in dataLanguages"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.language.$dirty && !$v.language.required" text="Please fill your language." />
            </div>
          </template>
        </form-item>
      </div>
      <div class="w-full lg:w-1/2">
        <form-item label='Date of Birth'>
          <template v-slot>
            <Input
              type="date"
              v-model="dob"
              placeholder="Date of Birth"
              :error="$v.dob.$dirty && (!$v.dob.required)"
            />
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.dob.$dirty && !$v.dob.required" text="Please fill your Birthdate." />
            </div>
          </template>
        </form-item>
        <form-item label='Bio'>
          <template v-slot>
            <div class="relative">
            <TextArea
              v-model="bio"
              placeholder="Tell us about you"
              :error="$v.bio.$dirty && (!$v.bio.required)"
              rows="3"
              :max-length="maxLengthBio"
            />
              <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 15px;" >{{bio.length}}/{{maxLengthBio}}</div>
            </div>
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.bio.$dirty && !$v.bio.required" text="Please fill your Bio." />
            </div>
          </template>
        </form-item>
        <form-item label='Password'>
          <template v-slot>
            <div class="relative">
              <Input
                :type="showPassword?'text':'password'"
                v-model="password"
                placeholder="Password"
                :error="$v.password.$dirty && (!$v.password.required)"
              />
              <a class="absolute top-0 right-0 mr-2 mt-3 " @click="showPassword=!showPassword" style="cursor:pointer">
                <i class="fa" :class="showPassword?'fa-eye-slash':'fa-eye'"></i>
              </a>
            </div>
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.password.$dirty && !$v.password.required" text="Please fill the password." />
            </div>
          </template>
        </form-item>
        <form-item label='Confirm Password'>
          <template v-slot>
            <div class="relative">
              <Input
                :type="showConfirmPassword?'text':'password'"
                v-model="repassword"
                placeholder="Confirm Password"
                :error="$v.repassword.$dirty && (!$v.repassword.required || !$v.repassword.sameAsPassword)"
              />
              <a class="absolute top-0 right-0 mr-2 mt-3 " @click="showConfirmPassword=!showConfirmPassword" style="cursor:pointer">
                <i class="fa" :class="showConfirmPassword?'fa-eye-slash':'fa-eye'"></i>
              </a>
            </div>
            <div class="flex flex-col pt-2">
              <text-error v-if="$v.repassword.$dirty && !$v.repassword.required" text="Please fill the confirm password." />
              <text-error v-if="$v.repassword.$dirty && !$v.repassword.sameAsPassword" text="Please fill correct the confirm password." />
            </div>
          </template>
        </form-item>
      </div>
    </div>
    <div class="text-center mt-6">
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import helpersMixin from '@/mixins/helpers.mixins';
import { required, sameAs, email, maxLength } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { FormItem, Button, Input, TextArea, TextError } from '@/components/Layout/Form';
import ImageCropModal from '@/components/Common/ImageCropModal';
import imgPlaceholder from '@/assets/image-placeholder.jpeg';

export default {
  name: 'FormSignupUser',
  mixins: [validationMixin, helpersMixin],
  props: {
    isEmailExist: {
      type: Boolean,
    },
    emailErrorMsg: {
      type: String,
    },
  },
  data: () => ({
    dataLanguages: [],
    maxLengthBio: 2000,
    isLoading: false,
    showPassword: false,
    showConfirmPassword: false,
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    repassword: '',
    profilePicture: null,
    bio: '',
    dob: '',
    language: '',
    imageErrorMessage: false,
    showCropModal: false,
    pendingImageSrc: null,
    errIsEmailExist: false,
    imgPlaceholder,
  }),
  validations: {
    first_name: {
      required,
      maxLength: maxLength(100),
    },
    last_name: {
      required,
      maxLength: maxLength(100),
    },
    email: {
      required,
      isExists: false,
      email,
      maxLength: maxLength(100),
    },
    password: {
      required,
      maxLength: maxLength(100),
    },
    repassword: {
      required,
      sameAsPassword: sameAs('password'),
      maxLength: maxLength(100),
    },
    bio: {
      required,
      maxLength: maxLength(2000),
    },
    dob: {
      required,
    },
    language: { required },
  },
  computed: {
    ...mapGetters('NotificationModule', ['getStatus', 'getLoading', 'getMessage', 'getErrorCode']),
    labelErrorImageMessage() {
      return this.imageErrorMessage ? 'Profile Picture is required' : '';
    },
  },
  watch: {
    isEmailExist(newVal) {
      this.errIsEmailExist = newVal;
    },
    getLoading: {
      immediate: true,
      handler(val) {
        this.isLoading = val;
      },
    },
  },
  mounted() {
    this.dataLanguages = this.getLanguages();
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      e.target.value = '';
      if (!file) return;
      if (!file.type || !file.type.startsWith('image/')) {
        this.$swal('Error', 'Please select an image file.', 'error');
        return;
      }
      this.revokePendingImage();
      this.pendingImageSrc = URL.createObjectURL(file);
      this.showCropModal = true;
    },
    onCropCropped({ url }) {
      this.profilePicture = url;
      this.revokePendingImage();
      this.showCropModal = false;
    },
    onCropCancel() {
      this.revokePendingImage();
      this.showCropModal = false;
    },
    revokePendingImage() {
      if (this.pendingImageSrc) {
        URL.revokeObjectURL(this.pendingImageSrc);
        this.pendingImageSrc = null;
      }
    },
    changeImage() {
      this.profilePicture = null;
    },
    validate() {
      this.$v.$touch();
      this.imageErrorMessage = this.profilePicture === null;
      const isValid = !this.$v.$invalid && !this.imageErrorMessage;
      this.$emit('on-validate', this.$data, isValid);
      return isValid;
    },
  },
  components: { FormItem, Button, Input, TextArea, TextError, ImageCropModal },
};
</script>
<style>
.el-input--suffix .el-input__inner{
  //height: 56px;
  //font-size: 18px;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/FormSignupUser.vue